import { LoginComponent } from '@app/components/login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error404Component } from '@app/components/error-404/error-404.component';
import { ErrorComponent } from '@app/components/error/error.component';
import { MainLayoutComponent } from '@layout/main-layout.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { UserSessionGuard } from '@app/guards/user-session.guard';

const MAIN_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
    },
    {
        path: 'home',
        redirectTo: 'projects',
        pathMatch: 'full'
    },
    {
        path: 'inventory',
        loadChildren: () => import('./modules/inventory/inventory.module').then(m => m.InventoryModule),
        data: {
            acl: {
                entity: 'inventory',
                level: 'READ'
            },
            breadcrumb: 'Inventaire'
        }
    },
    {
        path: 'users',
        loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
        data: {
            acl: {
                entity: 'user',
                level: 'READ'
            },
            breadcrumb: 'Utilisateurs'
        }
    },
    {
        path: 'companies',
        loadChildren: () => import('./modules/companies/companies.module').then(m => m.CompaniesModule),
        data: {
            acl: {
                entity: 'company',
                level: 'READ'
            },
            breadcrumb: 'Sociétés'
        }
    },
    {
        path: 'projects',
        loadChildren: () => import('./modules/projects/projects.module').then(m => m.ProjectsModule),
        data: {
            acl: {
                entity: 'project',
                level: 'READ'
            },
            breadcrumb: 'Projets'
        }
    },
    {
        path: 'search',
        loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule),
        data: {
            breadcrumb: 'Recherche globale'
        }
    },
    {
        path: 'business-projects',
        loadChildren: () => import('./modules/business-projects/business-project.module').then(m => m.BusinessProjectModule),
        data: {
            acl: {
                entity: 'business-project',
                level: 'READ'
            },
            breadcrumb: 'Business project'
        }
    },
    {
        path: 'organizations',
        loadChildren: () => import('./modules/organization/organization.module').then(m => m.OrganizationModule),
        data: {
            acl: {
                entity: 'cell',
                level: 'READ'
            },
            breadcrumb: 'Organisation'
        }
    },
    {
        path: 'apps',
        loadChildren: () => import('./modules/apps/apps.module').then(m => m.AppsModule),
        data: {
            acl: {
                entity: 'app',
                level: 'READ'
            },
            breadcrumb: 'Apps'
        }
    },
];

const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        children: MAIN_ROUTES,
        canActivate: [AuthGuard, UserSessionGuard],
    },
    {
        path: 'login',
        component: LoginComponent,
    },
    {
        path: 'error',
        component: ErrorComponent
    },
    {
        path: '**',
        component: Error404Component
    },
];

@NgModule({
    declarations: [
        Error404Component,
    ],
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule,
        Error404Component
    ]
})

export class AppRoutingModule {
}
